import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/18764390976?text=Hi%20Aristocrats%20JA!%20I'm%20interested%20in%20your%20services."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-24 z-[60] w-12 h-12 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_4px_24px_rgba(37,211,102,0.4)] hover:scale-110 hover:shadow-[0_6px_32px_rgba(37,211,102,0.5)] transition-all"
      title="Chat on WhatsApp"
    >
      <MessageCircle size={20} className="text-white" />
    </a>
  );
}
